import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { SharedService } from "./shared.service";

@Injectable()
export class AttendeeSessionService {
    public getSessionApi: string = "/svcs/session_catalog/app/es/instanceList";

    public sessionDocumentDownloadApi: string = "/svcs/session_catalog/app/conference_session_documents/download";
    public speakerDocumentDownloadApi: string = "/svcs/session_catalog/app/conference_speaker_documents/download";

    public favSessionApi: string = "/svcs/conference_sessions/catalog_reg_fav_instance";
    public processCartAPI: string = "/svcs/conference_session_instance_cart";
    public mySessionsCalendarDownloadApi: string = "/svcs/conference_sessions/my_scheduled_session/downloadCalendar?registrationUUID=";

    constructor(private http: HttpClient, public sharedService: SharedService) {
        if (sessionStorage.getItem("loggedInAttendee_" + this.sharedService.eventUUID) != null) {
            this.getSessionApi = "/svcs/conference_sessions/es/instanceList";
        }
    }

    public getSessions(filter?: any) {
        filter.eventId = this.sharedService.event.id;
        if (!filter.hasOwnProperty("isPublished") || !filter.hasOwnProperty("isScheduled")) {
            filter.isPublished = true;
        }
        if (['highlighted', 'promoted'].includes(filter.type)) {
            this.getSessionApi = "/svcs/session_catalog/app/es/instanceList";
        } 
        filter.catalogUUID = this.sharedService.setup.uuid;
        return this.http.post(this.getSessionApi, JSON.stringify(filter), {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getInstanceCount (filter) {
        let apiUrl = "/svcs/session_catalog/app/es/instanceCount";
        return this.http.post(apiUrl, JSON.stringify(filter), {
            observe: "response",
            headers: this.sharedService.headers
        }).toPromise();
    }
    
    public getMyScheduledSessions(registrationUUID: string, filter?: any) {
        filter.eventId = this.sharedService.event.id;
        if (!filter.hasOwnProperty("isPublished") || !filter.hasOwnProperty("isScheduled")) {
            filter.isPublished = true;
        }
        return this.http.post(
            "/svcs/conference_sessions/my_scheduled_session?registrationUUID=" + registrationUUID,
            JSON.stringify(filter),
            {
                observe: "response",
                headers: this.sharedService.headers
            }
        );
    }

    public downloadMySessionsCalendar(registrationUUID: string, filter?: any) {

        return this.http.post(this.mySessionsCalendarDownloadApi + registrationUUID, JSON.stringify(filter), {
            observe: "response",
            headers: this.sharedService.headers,
            responseType: "blob"
        });
    }

    public downloadSessionDocument(eventId, documentName, documentType, sessionId) {
        let body = new URLSearchParams();
        body.set("eventId", eventId);
        body.set("documentName", documentName);
        body.set("documentType", documentType);
        body.set("sessionId", sessionId);

        var headers = new HttpHeaders()
            .set("Content-Type", "application/x-www-form-urlencoded")
            .set("Access-Control-Allow-Origin", "*");

        return this.http.post(this.sessionDocumentDownloadApi, body.toString(), {
            observe: "response",
            headers: headers,
            responseType: "blob"
        });
    }

    public downloadSpeakerDocument(eventId, documentName, documentType, speakerId) {
        let body = new URLSearchParams();
        body.set("eventId", eventId);
        body.set("documentName", documentName);
        body.set("documentType", documentType);
        body.set("speakerId", speakerId);

        var headers = new HttpHeaders()
            .set("Content-Type", "application/x-www-form-urlencoded")
            .set("Access-Control-Allow-Origin", "*");

        return this.http.post(this.speakerDocumentDownloadApi, body.toString(), {
            observe: "response",
            headers: headers,
            responseType: "blob"
        });
    }

    public login(loginModal) {
        return this.http.post("/svcs/registration_user_login", JSON.stringify(loginModal), {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public forgotPassword(forgotPasswordModal, isPreview) {
        return this.http.post("/svcs/registration_forgot_password?isPreview=" + isPreview, JSON.stringify(forgotPasswordModal), {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public validatetoken(data) {
        return this.http.post("/svcs/validate_reset_password_link", JSON.stringify(data), {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public updatePassword(updatePassword) {
        return this.http.post("/svcs/update_password", JSON.stringify(updatePassword), {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

  	logout(registrationUUID) {
 	    return this.http.post("/svcs/registration_user_logout?registrationUUID=" + registrationUUID, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    getCartData(registrationUUID) {
        return this.http.post(
            "/svcs/conference_sessions/catalog_reg_cart_instance/cartlist?registrationUUID=" + registrationUUID,
            { eventId: this.sharedService.event.id, catalogUUID: this.sharedService.setup.uuid },
            {
                observe: "response",
                headers: this.sharedService.headers
            }
        );
    }

    addToCart(cartObjbect, instanceCheckValidation=false) {
        return this.http.post(this.processCartAPI + "?instanceCheckValidation=" +
        instanceCheckValidation, cartObjbect, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    removeFromCart(id, registrationUUID) {
        return this.http.delete(
            this.processCartAPI +
                "/remove?instanceId=" +
                id +
                "&registrationUUID=" +
                registrationUUID +
                "&catalogUUID=" +
                this.sharedService.setup.uuid,
            {
                observe: "response",
                headers: this.sharedService.headers
            }
        );
    }

    clearCart(registrationUUID) {
        return this.http.delete(
            this.processCartAPI +
                "/clear_cart?registrationUUID=" +
                registrationUUID +
                "&catalogUUID=" +
                this.sharedService.setup.uuid,
            {
                observe: "response",
                headers: this.sharedService.headers
            }
        );
    }

    processCart(registrationUUID, instanceCheckValidation=false) {
        return this.http.post(
            this.processCartAPI +
                "/process_cart?registrationUUID=" +
                registrationUUID +
                "&instanceCheckValidation=" +
                instanceCheckValidation,
            {
                catalogUUID: this.sharedService.setup.uuid
            },
            {
                observe: "response",
                headers: this.sharedService.headers
            }
        );
    }

    getFavoritesData(registrationUUID) {
        return this.http.post(
            this.favSessionApi + "/favlist?registrationUUID=" + registrationUUID,
            {
                eventId: this.sharedService.event.id,
                fetchExcludedSessions: true,
                catalogUUID: this.sharedService.setup.uuid
            },
            {
                observe: "response",
                headers: this.sharedService.headers
            }
        );
    }

    addToFavourite(favObjbect) {
        return this.http.post(this.favSessionApi, favObjbect, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    removeFromFavourite(registrationUUID, instanceId) {
        return this.http.delete(
            this.favSessionApi +
                "?registrationUUID=" +
                registrationUUID +
                "&confSessionInstanceId=" +
                instanceId,
            {
                observe: "response",
                headers: this.sharedService.headers
            }
        );
    }

    removeAllFromFavourite(registrationUUID, isExcluded) {
        return this.http.delete(
            this.favSessionApi +
                "/delete_all?registrationUUID=" +
                registrationUUID +
                "&isExcluded=" +
                isExcluded,
            {
                observe: "response",
                headers: this.sharedService.headers
            }
        );
    }

    getSessionApiOnLogin() {
        if (this.sharedService.loggedInAttendee != null && this.sharedService.loggedInAttendee != undefined) {
            this.getSessionApi = "/svcs/conference_sessions/es/instanceList";
        } else {
            this.getSessionApi = "/svcs/session_catalog/app/es/instanceList";
        }
    }

    onTimeZoneChange(type) {
        if (type == 'general') {
            if (this.sharedService.loggedInAttendee != null && this.sharedService.loggedInAttendee != undefined) {
                this.getSessionApi = "/svcs/conference_sessions/es/instanceList";
            } else {
                this.getSessionApi = "/svcs/session_catalog/app/es/instanceList";
            }
        } else {
            this.getSessionApi = "/svcs/session_catalog/app/es/instanceList";
        }
    }

    processFav(registrationUUID, confSessionInstanceId) {
        return this.http.post(
            this.favSessionApi +
                "/process_fav?registrationUUID=" +
                registrationUUID +
                "&confSessionInstanceId=" +
                confSessionInstanceId,
            {
                catalogUUID: this.sharedService.setup.uuid
            },
            {
                observe: "response",
                headers: this.sharedService.headers
            }
        );
    }

    processAllFav(registrationUUID) {
        return this.http.post(
            this.favSessionApi +
                "/process_all_fav?registrationUUID=" +
                registrationUUID,
            {
                catalogUUID: this.sharedService.setup.uuid
            },
            {
                observe: "response",
                headers: this.sharedService.headers
            }
        );
    }

    getRegistration(id) {
        return this.http.get("/svcs/registrations/" + id, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    getRegistrationByUUID() {
        return this.http.get("/svcs/registrations/findByUUID", {
            params: { regUUID: this.sharedService.regUUID, eventUUID: this.sharedService.eventUUID },
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    getSpeaker(speakerUsername, eventUUID) {
        return this.http.get("/svcs/session_catalog/app/conf_speaker", {
            params: { eventUUID: eventUUID, username: speakerUsername },
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    removeFromSchedule(id, registrationUUID) {
        return this.http.delete(this.processCartAPI + "/" + registrationUUID + "/conference_session_instances/" + id, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }
}
